export enum MutationTypes {
    SET_AVAILABLE_BRANDS = 'SET_AVAILABLE_BRANDS',
    SET_ERROR = 'SET_ERROR',
}
